import { Box, Button, Heading, Text } from "@chakra-ui/react";
import Card from "components/card";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const NotAutority = () => {
    const { userToken, user } = useSelector((state) => state.userReducer);
    return (
        <div className="mt-8 md:mt-4">
            <Card>
                <Box textAlign="center" py={10} px={6}>
                    <Heading display="inline-block" as="h2" size="4xl" bgGradient="linear(to-r, red.400, red.600)" backgroundClip="text">
                        401
                    </Heading>
                    <Text fontSize="24px" mt={3} mb={2} className="!text-red-500 dark:!text-red-400">
                        Página no permitida
                    </Text>
                    <Text fontSize="20px" className="!text-neutral-800 dark:!text-neutral-200" mb={6}>
                        La página que estás buscando esta prohibida para tu autoridad de <b>{userToken && user.autoridad}</b>.
                    </Text>
                </Box>
            </Card>
        </div >

    );
};

export default NotAutority;
